import axios from 'axios';
import { handleResponse, handleError } from './apiHelper';

export async function getPrivateClaims(token) {
  try {
    return handleResponse(await axios.get(privateClaimsUrl(), headers(token)));
  } catch (err) {
    return handleError(err);
  }
};

function privateClaimsUrl() {
  return `${govBrUrl()}/api/subject?apikey=${govBrApiKey()}`;
};

export async function getLinkedCompanies(cpf, token) {
  try {
    return handleResponse(await axios.get(linkedCompaniesUrl(cpf), headers(token)));
  } catch (err) {
    return handleError(err);
  }
};

function linkedCompaniesUrl(cpf) {
  return `${govBrUrl()}/api/company?document=${cpf}&apikey=${govBrApiKey()}`;
};

function govBrUrl() {
  return process.env.REACT_APP_GOVBRAPI_URL;
};

function govBrApiKey() {
  return process.env.REACT_APP_GOVBRAPIKEY;
};

function headers(token) {
  return { headers: { Authorization: `Bearer ${token}` } };
};
